"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spherical = void 0;
const gl_matrix_1 = require("gl-matrix");
class Spherical {
    constructor(_radius = 1, _phi = 0, _theta = 0) {
        this._radius = _radius;
        this._phi = _phi;
        this._theta = _theta;
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this._radius = value;
    }
    get phi() {
        return this._phi;
    }
    set phi(value) {
        this._phi = value;
    }
    get theta() {
        return this._theta;
    }
    set theta(value) {
        this._theta = value;
    }
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    fromVec3(p) {
        this.radius = Math.sqrt(p[0] * p[0] + p[1] * p[1] + p[2] * p[2]);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        }
        else {
            this.theta = Math.atan2(p[0], p[2]);
            this.phi = Math.acos(Math.max(-1, Math.min(1, p[1] / this.radius)));
        }
        return this;
    }
    toVec3() {
        const sinPhiRadius = Math.sin(this.phi) * this.radius;
        return gl_matrix_1.vec3.fromValues(sinPhiRadius * Math.sin(this.theta), Math.cos(this.phi) * this.radius, sinPhiRadius * Math.cos(this.theta));
    }
}
exports.Spherical = Spherical;
//# sourceMappingURL=Spherical.js.map